import React from 'react'
import { Glyphicon, Button } from 'react-bootstrap'
import Fa from 'react-fontawesome'

export default class MediaItem extends React.Component {

    render() {
        let url = this.props.url + this.props.singleItem.thumb
        let _overlayStyle = {minWidth: '96%', maxWidth:'96%'}
        let _imageStyle = {maxWidth: '715px', maxHeight:'715px'}
        let filename = this.props.singleItem.filename.length > 20 ? this.props.singleItem.filename.substring(0,20) + '...' : this.props.singleItem.filename

      return (
          <div className='media-image'>
            <img src={url}/>
            <div className="image-overlay"> 
                  <p style={{marginLeft:10, marginBottom:0}} title={this.props.singleItem.filename}>
                  {filename}
                  </p>
                  <p className='image-buttons'>
                    <button title="Edit"  className="btn btn-xs btn-info img-control" onClick={() => this.props.edit(this.props.index) }><Fa name="pencil"/></button>
                    <button title="Delete" className="btn btn-xs btn-danger img-control" onClick={() => this.props.delete(this.props.index) }><Fa name="times"/></button>
                </p>
            </div>

          </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/components/MediaItem.jsx